import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useCallback } from 'react';

export const AbvChannelSummaryList = ({ lbeId }) => {
    
    const augRowsReq = useCallback((rowsReq) => {
        rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('lbeId', lbeId));
    }, [lbeId]);
  
    return (
        <EntityList entity="CHANNEL_SUMMARY" augRowsReq={augRowsReq} />
    );
}